import { memo } from "react";
import { useDrop } from "react-dnd";
import { Typography } from "@material-ui/core";
import { GetTemplateEvents } from "./TermTemplateComponents.js";
import AddEventToTemplateDialog from "./AddEventToTemplateDialog.js";

export const EventDropBox = memo(function EventDropBox({
  lastDroppedComponent,
  closeAddDialog,
  onDrop,
  periodName,
  noOfWeeks,
  passObjOptions,
}) {
  
  const templateEvents = GetTemplateEvents();
  const acceptList = [];
  templateEvents.map((event) => {
    acceptList.push(event.name);
  });

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: acceptList,
    drop(_item, monitor) {
      onDrop(monitor.getItemType());
      return undefined;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      draggingColor: monitor.getItemType(),
    }),
  });
  return (
    <div
      ref={drop}
      role="EventDropBox"
      style={{
        border: "1px dashed grey",
        borderRadius: "8px",
        height: "70px",
        textAlign: "center",
        display: "flex",
      }}
    >
      <Typography
        variant="h6"
        style={{
          display: "flex",
          alignItems: "center",
          padding: 5,
        }}
      >
        Drag and drop Event object into this box.
      </Typography>
      {!canDrop && acceptList.includes(lastDroppedComponent) && (
        <AddEventToTemplateDialog
          closeDialog={closeAddDialog}
          handleAddEvent={passObjOptions}
          eventType={lastDroppedComponent}
          periodName = {periodName}
          noOfWeeks = {noOfWeeks}
        />
      )}
    </div>
  );
});
